import { Box, styled } from '@mui/material';
import { pxToRem } from '@themes';
var StyledPopupContainer = styled(Box)(function (_ref) {
  var theme = _ref.theme,
      $fullScreen = _ref.$fullScreen;
  var styles = {
    padding: !$fullScreen && theme.spacing(4),
    borderRadius: !$fullScreen && pxToRem(12),
    flex: $fullScreen && 1,
    display: 'flex',
    flexDirection: 'column',
    height: $fullScreen && '100%'
  };
  return styles;
});
export { StyledPopupContainer };